/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of InventoryPurchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../../../../@core/backend/common/api/http.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';

@Injectable()

export class ApprovalModuleApi{
    constructor(private api:HttpService){

    }

    list(url: string): Observable<any[]> {
        return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json"}});
      }
     
      searchList(url: string, data:any): Observable<any[]> {
        return this.api.post(url,data,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"}});
      }
     
      getById(url: string): Observable<any> {
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directGet(url,header);
      }
    
      create(url:string, data: any):Observable<any>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directPost(url, data, header);
      }
     
      update(url:string, data: any):Observable<any>{
        let header = new HttpHeaders();
        header.append('Content-Type', 'applications/json');
        header.append('Accept','application/vnd.ezovion.hateoas+json');
        return this.api.directPut( url, data, header);
      }
    
      delete(url: string):Observable<any>{
        return this.api.directDelete(url);
      }

      getByType(url: string,type: string,typeValue): Observable<any> {
        const params = new HttpParams().set(type, typeValue);
        return this.api.get(url,{headers:{"Accept":"application/vnd.ezovion.hateoas+json",'Content-Type': "application/json"},params});
      }
}